import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { makeSelectMyTimesheetEntryIsEditable } from './selectors';

interface OwnProps {
    children: React.ReactElement;
    FallbackComponent?: React.ReactElement;
    myTimesheetEntryUuid: string;
}

interface ConnectedProps {
    isEditable: boolean;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryIsEditable extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, FallbackComponent, isEditable } = this.props;

        if (!isEditable) {
            return FallbackComponent || null;
        }

        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isEditable: makeSelectMyTimesheetEntryIsEditable()
});

export default connect(mapStateToProps)(MyTimesheetEntryIsEditable);
